import { Component, Input } from '@angular/core';
import { BaseComponent, Helpers } from 'ngx-elvis-ds';
import { SAMService } from 'src/app/sam/sam.service';
import { MenuController } from '@ionic/angular';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { IconTranslator } from 'src/app/base/icon-translator';
import { WindowRef } from '../../../window-ref.service';

@Component({
  selector: 'elv-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent extends BaseComponent {

  sideMenuItems: any[] = [];
  @Input() menuNumber: string;

  constructor(
    public sam: SAMService,
    public menuCtrl: MenuController,
    private winRef: WindowRef
  ) {
    super();
    this.subscribeListeners();
  }

  onItemSelect(menuItem) {
    if (this.winRef.scrolling) {
      return;
    }

    this.sam.onSend({ Command: menuItem.Command });
    this.menuCtrl.close();
  }

  // private

  private subscribeListeners() {
    this.sam.channels.gui.subscribe((msg: SAMMessage) => {
      if (['SET_FUNC'].includes(msg.Command)) {
        const data = msg.parms;

        this.sideMenuItems = data.Functions.filter((f) => {
          f.icon = this.computeIcon('sideMenu', f.Command, f.Img);
          // f.icon = f.Img;
          return f.Command !== 'CMD_HIDDEN' && f.Position === this.menuNumber;
        });
      }
    });
  }

  private computeIcon(section, command, img) {
    if (section && command && IconTranslator.commands[section] && IconTranslator.commands[section][command]) {
      return IconTranslator.commands[section][command];
    } else {
      return img || 'square';
    }
  }

}
